import queryString from 'querystring';

import { isEmpty } from 'lodash';

import { FC, HTMLAttributes } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import ItemFilter from './ItemFilter';

import LocationButton from './LocationButton';

import { FilterItemModel } from '../../../../../models/filter.model';

import { collectionData, getCollection } from '../../../../../store/collection';
import {
    DataSchemeFilter,
    filterData,
    bookingYear,
    setBookingYear,
    getProductList,
    getProductDetails,
    getNeighborsProducts,
    dataProductFull,
} from '../../../../../store/location';
import { togglePopup } from '../../../../../store/ui';
// import { loadersByName, togglePopup } from '../../../../../store/ui';
import { getLabelFilterBlock } from '../../../../../utils';
import { Dropdown } from '../../input';

const Filter: FC<HTMLAttributes<HTMLDivElement>> = props => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const filterDataState = useSelector(filterData);
    const collection = useSelector(collectionData);
    const bookingyear = useSelector(bookingYear);
    // const locationLoading = useSelector(loadersByName('location'));
    // const productLoading = useSelector(loadersByName('product'));
    const { search, pathname } = window.location;
    const parsedSearch = queryString.parse(search.replace('?', ''));
    const isProductPage = pathname.includes('/location/product');
    const isShowShortFilter = true;

    const countItemData = (key: keyof DataSchemeFilter) => ({
        name: getLabelFilterBlock(intl)(key),
        value: (filterDataState[key] as FilterItemModel[]).filter(({ checked }) => checked).length || 0,
    });

    function isFilterItemModel(item: FilterItemModel[] | number | undefined | string): item is FilterItemModel[] {
        if (item) {
            return (item as FilterItemModel[]).length !== undefined && typeof (item as FilterItemModel[]) !== 'string';
        } else {
            return false;
        }
    }

    const countAllData = () => {
        let res = 0;

        (Object.keys(filterDataState) as Array<keyof DataSchemeFilter>).map(key => {
            if (isFilterItemModel(filterDataState[key]) && filterDataState[key]) {
                res += (filterDataState[key] as FilterItemModel[]).filter(({ checked }) => checked).length || 0;
            }
        });

        return res;
    };

    const getBookingYears = () => {
        if (Object.keys(filterDataState).includes('bookingyear')) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return filterDataState['bookingyear'];
        }
        return [];
    };

    const bookingYears = getBookingYears() as unknown as string[];

    const renderFilterList = (
        <div
            onClick={() => {
                dispatch(togglePopup({ name: 'location_filter', status: true }));
            }}
            {...props}
            className={props.className}
        >
            {isShowShortFilter ? (
                <ItemFilter
                    {...{
                        name: intl.formatMessage({ id: 'location.filter.pillName', defaultMessage: 'Filter' }),
                        value: countAllData(),
                    }}
                    key={'item-filter'}
                />
            ) : (
                (Object.keys(filterDataState) as Array<keyof DataSchemeFilter>).map(key =>
                    !isEmpty(filterDataState[key]) ? <ItemFilter {...countItemData(key)} key={key} /> : null
                )
            )}
        </div>
    );

    if (!isEmpty(filterDataState)) {
        if (isShowShortFilter) {
            return (
                <div className={'location-row-wrapper'}>
                    <div className={'location-row'}>
                        <LocationButton />
                        {bookingYears.length > 1 && (
                            <div className="bookingYear">
                                <Dropdown
                                    data={bookingYears}
                                    defaultSelected={bookingyear}
                                    onSelect={value => {
                                        dispatch(setBookingYear(value as number));
                                        dispatch(getProductList({ reset: true, bookingyear: value as number }));
                                        dispatch(getCollection(collection));
                                        if (isProductPage) {
                                            window.scrollTo(0, 0);
                                            dispatch(
                                                getProductDetails({
                                                    bookingyear: value as number,
                                                    urn: parsedSearch.urn as string,
                                                })
                                            );
                                        }
                                    }}
                                />
                            </div>
                        )}
                        {renderFilterList}
                    </div>
                </div>
            );
        }

        return renderFilterList;
    }

    return null;
};

export default Filter;
